// export const EP_BASE_API = 'https://localhost:44311';
export const EP_BASE_API = process.env.REACT_APP_API_URL;

export const EP_HOST = '/api/game/host';
export const EP_JOIN = '/api/game/join';
export const EP_GET_ROOM = '/api/game/getroom';
export const EP_LEAVE = '/api/game/leaveroom';

export const EP_START = '/api/action/{roomId}/{playerId}/start';
export const EP_READY = '/api/action/{roomId}/{playerId}/ready';
export const EP_PICK_DECK_CARD = '/api/action/{roomId}/{playerId}/pickDeckCard';
export const EP_PICK_DISCARDED_CARD = '/api/action/{roomId}/{playerId}/pickDiscardedCard';
export const EP_DISCARD = '/api/action/{roomId}/{playerId}/{cardId}/discard';
export const EP_DECLARE = '/api/action/{roomId}/{playerId}/{cardId}/declare';
export const EP_SHOW_WINNING_CARDS = '/api/action/{roomId}/{playerId}/show';
export const EP_GROUP_CARDS = '/api/action/{roomId}/{playerId}/groupCards';
export const EP_CHANGE_SETTING = '/api/action/{roomId}/{playerId}/{deckCount}/{jokerPairs}/changeSetting';
export const EP_CHANGE_NAME = '/api/action/{roomId}/{playerId}/{name}/changeName';
export const EP_REQUEST_SWAP = '/api/action/{roomId}/{playerId}/{targetPlayerId}/requestSwap';
export const EP_RESPONSE_SWAP = '/api/action/{roomId}/{playerId}/{requestPlayerId}/{isAccept}/responseSwap';

export const EP_SEND_MESSAGE = '/api/chat/{roomId}/{playerId}/sendMessage';

export const EP_GET_AC_TOKEN = '/api/voiceChat/token';

export const EP_GET_DASHBOARD = '/api/admin/dashboard';

// Auth
export const EP_AUTH_REGISTER_START = '/api/auth/register/start';
export const EP_AUTH_REGISTER_VERIFY = '/api/auth/register/verify-email';
export const EP_AUTH_REGISTER_COMPLETE = '/api/auth/register/complete';
export const EP_AUTH_RESEND_VERIFICATION = '/api/auth/resend-verification';
export const EP_AUTH_LOGIN = '/api/auth/login';
export const EP_AUTH_GOOGLE = '/api/auth/google';
export const EP_AUTH_GOOGLE_COMPLETE = '/api/auth/google/complete';
export const EP_AUTH_REFRESH = '/api/auth/refresh';
export const EP_AUTH_LOGOUT = '/api/auth/logout';
export const EP_AUTH_FORGOT_PASSWORD = '/api/auth/forgot-password';
export const EP_AUTH_RESET_PASSWORD = '/api/auth/reset-password';
export const EP_AUTH_CHANGE_PASSWORD = '/api/auth/change-password';
export const EP_AUTH_CHANGE_USERNAME = '/api/auth/change-username';
export const EP_AUTH_PASSWORD_SETUP_REQUEST = '/api/auth/set-password/request';
export const EP_AUTH_ME = '/api/auth/me';
export const EP_AUTH_DELETE_REQUEST = '/api/auth/delete-account/request';
export const EP_AUTH_DELETE_CONFIRM = '/api/auth/delete-account/confirm';
export const EP_AUTH_PUBLIC_CONFIG = '/api/auth/public-config';
export const EP_MY_ROOM = '/api/game/myroom';
